module.exports = __webpack_public_path__ + "static/media/portuguese-flag.280e99f3.svg";